import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

const OutlinedInput = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    paddingTop:0,
    paddingBottom:0,
    marginTop:8,
    marginBottom:8,
    "& fieldset": {
      border:'1px solid #ACACAC',
    },
    "&:hover fieldset": {
      borderColor: "primary", 
    },
    "&.Mui-focused fieldset": {
      borderColor: "primary", 
    },
  },
  "& .MuiInputBase-root":{
    maxHeight:'40px'
  },

  "& .MuiInputLabel-root": {
    color: "gray", 
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "primary",
  },
});

export default OutlinedInput;
